<template>
  <div class="dashboard-container">
    <OrgCardItem ></OrgCardItem>
  </div>
</template>
<script>
import OrgCardItem from './admin/components/OrgInfo.vue'

export default {
  name: 'seljgbm',
  components: { OrgCardItem },
  data() {
    return {
      currentRole: 'adminDashboard',
      orgs:[{
          orgInfo:{
                


          }  

      }]
    }
  }
}
</script>
